export const environment = {
  production: true,
  buildId: '3361571323321881',
  configFile: 'config.json',
};
